import stride from './stride'

/**
 * Scroll to a position inside a widget instance by its uuid and a relative offset.
 *
 * @param {String} uuid The uuid of the widget instance to scroll to.
 * @param {Number} offset An offset from the widget's top in pixel.
 * @returns {void}
 */
function goToWidget(uuid, offset) {
  var widgetOffset = this.utils.widgetLoader.getWidgetOffset(uuid)
  stride(document.body, widgetOffset + (offset || 0))
  stride(document.documentElement, widgetOffset + (offset || 0))
}

export default goToWidget
